import consts from '@/consts'
import local from '@/local'
import { HTTP } from 'shared'

const http = new HTTP('https://api.' + local.domain, consts.agent)

export default http
